import { AdditiveBlending } from 'three';

import { COLORS } from '../../constants.js';
import { globalUniforms } from '../../utils/uniforms.js';

import PBRMaterial from '../PBR/PBR.js';
import replacesFs from './replaces.fs?hotReplace';
import replacesVs from './replaces.vs?hotReplace';

class Lights extends PBRMaterial {
	constructor(config, caller) {
		config.envMapIntensity = 1;
		super(config, caller);

		this.uniforms.uTime = globalUniforms.uTime;
		this.uniforms.uSpeech = { value: 0.5 };

		if (caller.userData.glow) {
			this.defines.GLOW = 1;
			this.transparent = true;
			this.blending = AdditiveBlending;
		}
		this.defines.BLUE = COLORS.BLUE;
		this.defines.USE_UV = 1;

		replacesFs.use(this);
		replacesVs.use(this);
	}

	get speechVolume() {
		return this.uniforms.uSpeech.value;
	}
	set speechVolume(value) {
		this.uniforms.uSpeech.value = value;
	}
}

export default Lights;
